import { createTheme } from '@material-ui/core';
import { useMemo } from 'react';
const defaultTheme = require('tailwindcss/defaultTheme');

const typographyTheme = createTheme({
  typography: {
    fontFamily: ['-apple-system', 'Open Sans', ...defaultTheme.fontFamily.sans] as any,
  },
});

declare module '@material-ui/core/styles/createBreakpoints' {
  interface BreakpointOverrides {
    xs: true;
    sm: true;
    md: true;
    lg: true;
    xl: true;
  }
}

export const pixelOrange = {
  light: '#ffe998',
  main: '#edb769',
  dark: '#b8873c',
  contrastText: '#000',
};
export const pixelGreen = {
  light: '#8dc3ae',
  main: '#69938c',
  dark: '#466263',
};

export function useCreateTheme() {
  return useMemo(
    () =>
      createTheme(typographyTheme, {
        breakpoints: {
          values: {
            xs: 640,
            sm: 891, // Desktop + Laptop halfscreen (891px)
            md: 1280, // 5K halfscreen & Laptop (1280px)
            lg: 1440, // Laptop (1440px)
            xl: 1920, // Desktop (1920px)
          },
        },
        palette: {
          primary: {
            // Pixel blue-gray as main. Material
            light: '#5c6a7b',
            main: '#323f4f',
            dark: '#0b1927',
            contrastText: '#fff',
          },
          info: {
            // Pixel orange
            light: '#ffe998',
            main: '#edb769',
            dark: '#b8873c',
            contrastText: '#000',
          },
          secondary: {
            // Pixel green
            //light: '#aad4b4ff',
            light: '#8dc3ae',
            main: '#69938c',
            dark: '#466263',
          },
          //blue: '#0095ff'
          //opti-green: '#5BBA9C'
        },
        props: {
          MuiDialog: {
            transitionDuration: 100,
          },
          MuiButtonBase: {
            disableRipple: true,
          },
        },
        overrides: {
          MuiTableRow: {
            root: {
              '&hover': {},
              '&.Mui-selected': {
                '&:hover': {},
              },
            },
          },
          MuiTableCell: {
            root: {
              borderBottom: '0.5px solid rgba(224, 224, 224, 0.6)',
            },
            sizeSmall: {
              padding: '10px 24px 10px 16px',
            },
            stickyHeader: {
              backgroundColor: 'rgb(255, 255, 255)',
            },
          },
          /* MuiCheckbox: {
            root: {
              color: 'rgba(0,0,0,0.7)',
            },
          }, */
          MuiButton: {
            root: {
              color: 'rgba(0, 0, 0, 0.84)',
            },
            outlined: {
              border: '1px solid rgba(0,0,0,0.7)',
              '&.Mui-disabled': {
                borderWidth: '1px',
              },
            },
          },
          MuiIconButton: {
            root: {
              color: 'rgba(0, 0, 0, 0.7)',
            },
          },
          /* MuiInput: {
            underline: {
              '&:before': {
                borderBottom: '1px solid rgba(0,0,0,0.12)',
              },
              '&:after': {
                borderBottom: '1px solid rgba(0,0,0,0.7)',
              },
            },
          },
          MuiOutlinedInput: {
            root: {
              '&$focused $notchedOutline': {
                borderColor: 'rgba(0,0,0,0.7)',
                borderWidth: 1,
              },
              '&:hover $notchedOutline': {
                borderWidth: 1,
              },
            },
            notchedOutline: {
              borderColor: 'rgba(0,0,0,0.12)',
            },
          },
          MuiFormLabel: {
            root: {
              '&.Mui-focused': {
                color: 'rgba(0,0,0,0.87)',
              },
              '&.Mui-disabled': {
                color: 'rgba(0,0,0,0.37)',
              },
            },
          }, */
          MuiDialogTitle: {
            root: {
              padding: '32px',
            },
          },
          MuiDialogContent: {
            root: {
              padding: '8px 32px',
            },
          },
          MuiDialogActions: {
            root: {
              padding: '24px 32px',
            },
          },
          MuiListItem: {
            button: {
              transition: 'none',
            },
          },
        },
      }),
    [typographyTheme]
  );
}
